<template>
  <div class="row">
    <div class="col-sm-6">
      <form v-on:submit.prevent="save">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Member ids(such as xxx,xxx,xxx)</label>
              <input
                type="text"
                name="xxx"
                required="required"
                class="form-control"
                v-model="msg.condition.member_ids"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Title (Optional)</label>
              <input type="text" class="form-control" v-model="msg.title" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Message Type</label>
              <select class="form-control" v-model="msg.category">
                <option v-for="(item, index) in categories" :key="index">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Text</label>
              <textarea
                class="form-control"
                required="required"
                style="height: 10em"
                v-model="msg.text"
                name="content_en"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Enter App Path </label>
              <input
                type="text"
                name="link"
                required="required"
                class="form-control"
                v-model="msg.link"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>Delivery Method</label>
              <select class="form-control" v-model="msg.channel">
                <option value="inner_msg">Push and In-app message</option>
                <option value="app">Push only</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <label>When to send this Notification?</label>
              <br class="clear" />
              <label class="radio-inline">
                <input
                  type="radio"
                  name="when"
                  value="now"
                  v-model="msg_type"
                />
                Immediately
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  name="when"
                  value="later"
                  v-model="msg_type"
                />
                Scheduled Date
              </label>
            </div>
          </div>
        </div>

        <div c lass="row" v-show="msg.scheduled_at != null">
          <div c la ss="col-xs-12 datet ime">
            <div class="form-group">
              <label>D ate Time</label><br />
              <input
                type="datetime-local"
                name="bdaytime"
                v-bind:required="msg.scheduled_at != null"
                v-model="msg.scheduled_at"
                class="form-contl datepicker"
              />
            </div>
          </div>
        </div>
        <div class="row submit">
          <div class="cols-12">
            <button class="btn btn-lg btn-success pns-submit">
              Send Notification
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="col-sm-6">
      <h4>Preview</h4>
      <p><label for="">To</label> {{ msg.condition.member_ids }}</p>
      <p><label for="">Title</label>&nbsp;{{ msg.title }}</p>
      <p><label for="">Text</label>&nbsp;{{ msg.text }}</p>
      <p v-show="msg.link"><label for="">Link</label> {{ msg.link }}</p>
      <p v-show="msg.scheduled_at">
        <label for="">schedule</label> {{ msg.scheduled_at }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["msg"],
  data() {
    return {
      categories: ["events", "Dining news"],
    };
  },
  methods: {
    save() {
      this.$emit("onsave");
    },
  },
  computed: {
    msg_type: {
      get() {
        if (this.msg.scheduled_at == null) {
          return "now";
        } else {
          return "later";
        }
      },
      set(val) {
        if (val == "now") {
          this.msg.scheduled_at = null;
        } else {
          this.msg.scheduled_at = "Time";
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// member_msg_form.vue?5eca1e8e